<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M8.5 7.5h2.2l1.3-1.8h3l1.3 1.8H17a2 2 0 012 2v8.5a2 2 0 01-2 2H7a2 2 0 01-2-2v-8.5a2 2 0 012-2z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <circle cx="12" cy="13.25" r="3.25" stroke="currentColor" stroke-width="1.5" />
    <circle cx="17.2" cy="9.8" r="0.9" fill="currentColor" />
  </svg>
</template>
